import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import {
  loadHrAssistantSettingsEffect,
  updateHrAssistantSettingsEffect,
} from './assistant-settings.effects';
import { AssistantSettingsNamespace, AssistantSettingsReducer } from './assistant-settings.state';

const effects = { loadHrAssistantSettingsEffect, updateHrAssistantSettingsEffect };
export const provideHrAssistantEffects = provideEffects(effects);
export const provideHrAssistantState = provideState(
  AssistantSettingsNamespace,
  AssistantSettingsReducer,
);

@NgModule({
  imports: [
    StoreModule.forFeature(AssistantSettingsNamespace, AssistantSettingsReducer),
    EffectsModule.forFeature(effects),
  ],
})
export class HrAssistantSettingsStoreModule {}
